import { create } from 'zustand';

type ChannelsStore = {
  channelsLoading: boolean;
  setChannelsLoading: (loading: boolean) => void;
  shouldRefetchChannels: boolean;
  refetchChannels: () => void;
  resetRefetchChannels: () => void;
};

export const useChannelsStore = create<ChannelsStore>()((set) => ({
  channelsLoading: false,
  setChannelsLoading: (loading: boolean) => set(() => ({ channelsLoading: loading })),
  shouldRefetchChannels: false,
  refetchChannels: () => set(() => ({ shouldRefetchChannels: true })),
  resetRefetchChannels: () => set(() => ({ shouldRefetchChannels: false })),
}));
